import { css } from '@emotion/css';
import React from 'react';
import { TitleHeader, TitleHeaderProps } from '../shared/TitleHeader';

type PageLayoutProps = TitleHeaderProps & { background?: string };

export const PageLayout: React.FC<PageLayoutProps> = ({ children, background, ...rest }) => {
  return (
    <main
      className={css`
        width: 100%;
        height: 100%;
        overflow: hidden;
        background: ${background ?? '#f5f1e3'};
        isolation: isolate;
      `}
    >
      <TitleHeader {...rest} />
      <div
        className={css`
          height: calc(100% - 52px);
          overflow: auto;
        `}
      >
        {children}
      </div>
    </main>
  );
};
